<template>
  <div>
    <PageAllow controller="Receipt" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- TODO: 缺接口，后需要补权限 -->
              <!-- 批量收付款 -->
              <v-btn small color="primary" dark class="ms-1 d-none">
                <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                {{ $t("Receipt.batch_receipt") }}
              </v-btn>
              <!-- 批量对账 -->
              <v-menu
                v-if="
                  $permission.permissionAllow('Receipt', 'batchCheckBill') ||
                  $permission.permissionAllow('Receipt', 'batchUncheckBill')
                "
                v-model="checkBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                    {{ $t("Receipt.batch_bill_check") }}
                    <v-icon x-small class="ps-1">
                      {{ checkBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 批量对账 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('Receipt', 'batchCheckBill')
                    "
                    @click="batchCheckDialog = true"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.batch_bill_check") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 批量解除对账 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('Receipt', 'batchUncheckBill')
                    "
                    @click="batchUncheckDialog = true"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.batch_bill_uncheck") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu
                v-if="
                  $permission.permissionAllow('Receipt', 'export') ||
                  $permission.permissionAllow('Receipt', 'batchDetailExport') ||
                  ($permission.permissionAllow(
                    'Receipt',
                    'orderBillRecordsExport'
                  ) &&
                    options.obj_type == 1 &&
                    billTypesSelected == 101)
                "
                v-model="exportBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("Order.actions.batchExports") }}
                    <v-icon x-small class="ps-1">
                      {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 导出EXCEL -->
                  <v-list-item
                    v-if="$permission.permissionAllow('Receipt', 'export')"
                    @click.stop="exportExcel()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 批量对账单详情下载 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'batchDetailExport'
                      )
                    "
                    @click.stop="exportBatchExcel()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.bill_details_batch_export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 要货单付款明细下载 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'orderBillRecordsExport'
                      ) &&
                      options.obj_type == 1 &&
                      billTypesSelected == 101
                    "
                    @click.stop="orderBillRecordsExport()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.order_bill_records_export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 应收详情下载 -->
                  <v-list-item
                    v-if="
                      options.obj_type == 1 &&
                      billTypesSelected == 101 &&
                      $permission.permissionAllow(
                        'Receipt',
                        'subAccountReceivableDetailExport'
                      )
                    "
                    @click.stop="subAccountReceivableDetailExport()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.sub_account_receivable_detail_export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 要货对账单 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'resourceOrderExport'
                      ) &&
                      options.obj_type == 1 &&
                      billTypesSelected == 101
                    "
                    @click.stop="resourceOrderExport()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.resource_order_export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 采购对账单 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'supplierOrderExport'
                      ) &&
                      options.obj_type == 2 &&
                      billTypesSelected == 201
                    "
                    @click.stop="supplierOrderExport()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.supplier_order_export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 退货对账单 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'resourceReturnOrderExport'
                      ) &&
                      options.obj_type == 1 &&
                      billTypesSelected == 102
                    "
                    @click.stop="resourceReturnOrderExport()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.resource_return_order_export") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 要货对账单支付详情导出 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'resourceOrderPaymentExport'
                      ) &&
                      options.obj_type == 1 &&
                      billTypesSelected == 101
                    "
                    @click.stop="resourceOrderPaymentExport()"
                  >
                    <v-list-item-title>
                      {{ $t("Receipt.resource_order_payment_export") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherObjType v-model="options.obj_type" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherBillType
                    v-model="billTypesSelected"
                    :obj-type="options.obj_type"
                    @change="billTypeChange()"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="options.obj_type == 1">
                  <SearcherShops
                    v-if="settings && settings.shop_count < 1000"
                    v-model="shopsSelected"
                    isCompanyName="1"
                  />
                  <SearcherKeyword
                    v-else
                    ref="obj_name"
                    v-model="options.obj_name"
                    @text="obj_name = $event"
                    :label="$t('Shop.shopsKeyword', [$consts.shopName()])"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="options.obj_type == 2">
                  <SearcherSuppliers v-model="supplierSelected"/>
<!--                  <SearcherKeyword-->
<!--                    ref="obj_name"-->
<!--                    v-model="options.obj_name"-->
<!--                    @text="Keyword = $event"-->
<!--                    :label="$t('Receipt.Fields.name_code')"-->
<!--                  />-->
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="org_code"
                    v-model="options.org_code"
                    @text="org_code = $event"
                    :label="$t('Receipt.Fields.org_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_code"
                    v-model="options.bill_code"
                    @text="bill_code = $event"
                    :label="$t('Receipt.Fields.bill_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="options.obj_type == 2">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="order_code = $event"
                    :label="$t('Receipt.Fields.order_code')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="options.obj_type == 1 && billTypesSelected == 101"
                >
                  <SearcherOrderOriginFlgs v-model="options.origin_flgs" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                  />
                </v-col>
                <!-- 仓库 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="options.obj_type == 2"
                >
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <!-- 仓库 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="options.obj_type == 3"
                >
                  <SearcherStocks v-model="stocksSelected" :identity-type="[2]" />
                </v-col>
                <!-- 订单转采购门店名称/编号 -->
                <v-col cols="12" sm="6" md="4" v-if="options.obj_type == 2">
                  <v-row dense align="center">
                    <v-col cols="11">
                      <SearcherShop
                        v-if="selectShopFlg"
                        ref="orderToPurchaseShop"
                        v-model="orderToPurchaseShop"
                        :label="$t('Receipt.Fields.purchase_shop_name')"
                      />
                      <SearcherKeyword
                        v-else
                        ref="order_to_purchase_shop_name"
                        v-model="options.order_to_purchase_shop_name"
                        @text="purchase_shop_name = $event"
                        :label="$t('Receipt.Fields.purchase_shop_name')"
                      />
                    </v-col>
                    <v-col cols="1" class="pa-0">
                      <v-tooltip top v-if="selectShopFlg">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            fab
                            text
                            @click.stop="selectShopFlg = !selectShopFlg"
                          >
                            <v-icon color="primary">fa-toggle-off</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("Receipt.Fields.selectShop") }}</span>
                      </v-tooltip>
                      <v-tooltip top v-else>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            fab
                            text
                            @click.stop="selectShopFlg = !selectShopFlg"
                          >
                            <v-icon color="primary">fa-toggle-on</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("Receipt.Fields.textShop") }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- 财务状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.payFlgs.title')"
                    :items="$consts.financeFlgs"
                    v-model="options.pay_flg"
                  />
                </v-col>
                <!-- 对账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.billCheckFlg.title')"
                    :items="$consts.billCheckFlg"
                    v-model="options.bill_check_flg"
                  />
                </v-col>
                <!-- 归账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.billStatus.title')"
                    :items="$consts.billFlgs"
                    v-model="options.bill_status"
                  />
                </v-col>
                <!-- 作废状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.cancelFlgs.title')"
                    :items="$consts.cancelFlgs"
                    v-model="options.cancel_flgs"
                  />
                </v-col>
                <!-- 是否超收/超付 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.beyondStatus.title')"
                    :items="$consts.beyondStatus"
                    v-model="options.beyond_status"
                  />
                </v-col>
                <!-- 订单状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-if="options.obj_type == 1 && billTypesSelected == 101"
                    v-model="orderStatus"
                    :label="$t('Order.status.title')"
                    :items="$consts.order.status"
                  />
                  <SearcherStatus
                    v-if="options.obj_type == 1 && billTypesSelected == 102"
                    v-model="returnOrderStatus"
                    :items="$consts.return_order.status"
                    :label="$t('ReturnOrder.status.title')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="options.obj_type == 1 && billTypesSelected == 102">
                  <SearcherStatus
                    v-model="options.return_types"
                    :label="$t('ReturnOrder.Fields.type')"
                    :items="$consts.return_order.type"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 汇总 -->
        <div class="mx-4 mb-4" :items="bill_count">
          <v-row>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  <h5>{{ $t("Receipt.receivable") }}</h5>
                  <span class="caption secondary--text">
                    {{ $t("Receipt.receivable_remark") }}
                  </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content
                    >{{ $t("Receipt.receivable_fee_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ bill_count.receivable_fee_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.received_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ bill_count.received_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.wait_receive")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ bill_count.wait_receive_total | formatMoney }}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  <h5>{{ $t("Receipt.payable") }}</h5>
                  <span class="caption secondary--text">
                    {{ $t("Receipt.payable_remark") }}
                  </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content
                    >{{ $t("Receipt.pay_fee_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ bill_count.pay_fee_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.paid_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ bill_count.paid_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.wait_pay")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ bill_count.wait_pay_total | formatMoney }}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:header.created="{ header }">
              <span v-if="options.datetimeRadioSelected == 'created'">
                {{ header.text }}
              </span>
              <span v-else-if="options.datetimeRadioSelected == 'actual'">
                {{ $t("Receipt.Fields.actual_time") }}
              </span>
              <span v-else-if="options.datetimeRadioSelected == 'purchase'">
                {{ $t("Receipt.Fields.purchase_time") }}
              </span>
            </template>
            <!-- 原单号 -->
            <template v-slot:item.org_code="{ item }">
              <span v-if="item.bill_type == 101">
                <a
                  style="text-decoration: none"
                  :href="'/#/orders/' + item.order_id"
                >
                  {{ item.org_code }}
                </a></span
              >
              <span v-else-if="item.bill_type == 102">
                <a
                  style="text-decoration: none"
                  :href="'/#/return-orders/' + item.order_id"
                >
                  {{ item.org_code }}
                </a></span
              >
              <span v-if="item.bill_type == 201">
                <a
                  style="text-decoration: none"
                  :href="'/#/stock-orders-in/' + item.stock_order.id"
                >
                  {{ item.org_code }}
                </a></span
              >
              <span v-if="item.bill_type == 202">
                <a
                  style="text-decoration: none"
                  :href="'/#/stock-orders-out/' + item.stock_order.id"
                >
                  {{ item.org_code }}
                </a></span
                >
              <span v-if="item.bill_type == 203">
                <a
                    style="text-decoration: none"
                    :href="'/#/return-purchases/' + item.purchase.id"
                >
                  {{ item.org_code }}
                </a>
              </span>
              <span v-if="item.bill_type == 301 || item.bill_type == 302">
                <a
                  style="text-decoration: none"
                  :href="'/#/requisitions/' + item.requisition_id"
                >
                  {{ item.org_code }}
                </a>
              </span>
            </template>
            <template v-slot:item.order_return_type="{ item }">
              <v-chip
              small
              label
              :color="item.order_return_type | returnOrderTypesColor"
              :text-color="item.order_return_type | returnOrderTypesTextColor"
              >{{ item.order_return_type | returnOrderTypesText }}
              </v-chip>
            </template>
            <!-- 应收应付 -->
            <template v-slot:item.total_price="{ item, index }">
              <span
                class="text-no-wrap"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                <v-chip
                  small
                  label
                  color="primary"
                  dark
                  v-if="item.io_type == 1"
                >
                  {{ item.io_str }}
                </v-chip>
                <v-chip
                  small
                  label
                  color="danger"
                  dark
                  v-if="item.io_type == 2"
                >
                  {{ item.io_str }}
                </v-chip>
                <v-chip
                  small
                  label
                  color="danger"
                  dark
                  v-if="item.io_type == 3"
                >
                  {{ item.io_str }}
                </v-chip>
                {{ $t("Global.money") }}
                {{ item.total_price | formatMoney }}
              </span>
            </template>
            <!-- 待收/待付 -->
            <template v-slot:item.wait_fee="{ item }">
              <span class="text-no-wrap">
                <v-chip
                  small
                  label
                  color="primary"
                  dark
                  v-if="item.wait_io_type == 1"
                >
                  <span v-if="item.total_price < item.down_sum - item.up_sum">
                    {{ $t("Receipt.Fields.retreat") }}
                  </span>
                  <span v-else>{{ item.wait_io_str }}</span>
                </v-chip>
                <v-chip
                  small
                  label
                  color="danger"
                  dark
                  v-if="item.wait_io_type == 2"
                >
                  {{ item.wait_io_str }}
                </v-chip>
                <v-chip
                  small
                  label
                  color="danger"
                  dark
                  v-if="item.wait_io_type == 3"
                >
                  {{ item.wait_io_str }}
                </v-chip>
                {{ $t("Global.money") }}
                <!-- 当待收待付类型为退或者付时 -->
                <span
                  v-if="item.wait_io_type == '2' || item.wait_io_type == '3'"
                >
                  {{ item.wait_pay_price | formatMoney }}
                </span>
                <span v-else>
                  {{ item.wait_receive_price | formatMoney }}
                </span>
              </span>
            </template>
            <!-- 单号 -->
            <template v-slot:item.bill_code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.bill_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.bill_type_str }}
              </span>
              <v-chip
                v-if="item.cancel_flg"
                x-small
                label
                outlined
                color="danger"
                >{{ $t("CRUD.cancelled") }}
              </v-chip>
            </template>
            <!-- 对象 -->
            <template v-slot:item.shop_name="{ item }">
              <span v-if="options.obj_type == 1">
                <span class="text-no-wrap caption font-weight-bold">
                  {{item.shop ? item.shop.shop_name : "" }}
                </span>
                <br/>
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{item.shop ? item.shop.shop_code : "" }}
                </span>
              </span>
              <span v-if="options.obj_type == 2">
                <span
                  v-if="!loading"
                  class="text-no-wrap caption secondary--text"
                >
                  {{
                    item.stock_order
                        ? item.stock_order.shop
                            ? item.stock_order.shop.shop_name
                            : ""
                        : ""
                  }}
                </span>
                <br />
                <span class="text-no-wrap caption font-weight-bold">
                  {{item.supplier ? item.supplier.supplier_name : "" }}
                </span>
                <br/>
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{item.supplier ? item.supplier.supplier_code : "" }}
                </span>
              </span>
              <span v-if="options.obj_type == 3">
                <span class="text-no-wrap caption font-weight-bold">
                  {{item.stock_name ? item.stock_name : "" }}
                </span>
                <br/>
                <span
                    class="text-no-wrap caption secondary--text"
                    :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{item.stock_code ? item.stock_code : "" }}
                </span>
              </span>
            </template>
            <template v-slot:item.created="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                <span v-if="options.datetimeRadioSelected == 'created'">
                  {{ item.created | formatTime }}
                </span>
                <span v-else-if="options.datetimeRadioSelected == 'actual'">
                  {{ item.actual_date | formatTime }}
                </span>
                <span v-else-if="options.datetimeRadioSelected == 'purchase'">
                  {{
                    item.stock_order
                      ? item.stock_order.bill_purchase
                        ? item.stock_order.bill_purchase.created
                        : ""
                      : "" | formatTime
                  }}
                </span>
              </span>
            </template>
            <!-- 按钮  -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Receipt', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      $router.push({
                        path: '/receipts/' + item.id,
                        query: {
                          time_type:
                            options.datetimeRadioSelected == 'actual'
                              ? 2
                              : options.datetimeRadioSelected == 'created'
                              ? 1
                              : 3,
                        },
                      })
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("Receipt.details") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.details") }}</span>
              </v-tooltip>

              <v-tooltip
                top
                v-if="$permission.permissionAllow('Receipt', 'detailExport')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click="download(item.id)"
                  >
                    <v-icon x-small class="pe-1">fa-file-export</v-icon>
                    {{ $t("Receipt.bill_details_export") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.bill_details_export") }}</span>
              </v-tooltip>
              <!-- 对账 -->
              <v-tooltip
                top
                v-if="
                  item.actions.check_bill &&
                  $permission.permissionAllow('Receipt', 'checkBill') &&
                  item.status != 3
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      itemId = item.id;
                      checkBillMemo = item.memo;
                      billCheckDialog = true;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                    <span>
                      {{ $t("Receipt.bill_check") }}
                    </span>
                  </v-btn>
                </template>
                {{ $t("Receipt.bill_check") }}
              </v-tooltip>
              <!-- 解除对账 -->
              <v-tooltip
                top
                v-if="
                  item.actions.uncheck_bill &&
                  $permission.permissionAllow('Receipt', 'uncheckBill')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      itemId = item.id;
                      unBillCheckDialog = true;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-yen-sign</v-icon>
                    <span>
                      {{ $t("Receipt.uncheck_bill") }}
                    </span>
                  </v-btn>
                </template>
                {{ $t("Receipt.uncheck_bill") }}
              </v-tooltip>
              <!-- 收款 -->
              <v-tooltip
                top
                v-if="
                  item.io_type == 1 &&
                  $permission.permissionAllow('Receipt', 'saveBillRecord') &&
                  item.status != 3
                "
              >
                <!-- 额外提取出wait_pay_price是因为保证金额显示不被输入框修改 -->
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="settings && !settings.sub_account_enable"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      Dialog = true;
                      wait_pay_price = item.wait_pay_price;
                      wait_receive_price = item.wait_receive_price;
                      currentItem = JSON.parse(JSON.stringify(item));
                      currentItem = Object.assign({}, currentItem, {
                        bill_record_time: new Date()
                          .toISOString()
                          .substr(0, 10),
                        pay_type_shop: $permission.permissionAllow(
                          'Shops',
                          'getShopBalanceHistories'
                        )
                          ? 101
                          : 102,
                        pay_type_supplier: 102,
                        pay_type_stock: 102,
                      });
                    "
                  >
                    <v-icon x-small class="pe-1">fa-money-check</v-icon>
                    {{ $t("Receipt.collection") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.collection") }}</span>
              </v-tooltip>
              <!-- 付款 -->
              <v-tooltip
                top
                v-if="
                  item.io_type == 2 &&
                  $permission.permissionAllow('Receipt', 'saveBillRecord') &&
                  item.status != 3
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      Dialog = true;
                      wait_pay_price = item.wait_pay_price;
                      wait_receive_price = item.wait_receive_price;
                      currentItem = JSON.parse(JSON.stringify(item));
                      currentItem = Object.assign({}, currentItem, {
                        bill_record_time: new Date()
                          .toISOString()
                          .substr(0, 10),
                        pay_type_shop: $permission.permissionAllow(
                          'Shops',
                          'getShopBalanceHistories'
                        )
                          ? 101
                          : 102,
                        pay_type_supplier: 102,
                        pay_type_stock: 102,
                      });
                    "
                  >
                    <v-icon x-small class="pe-1">fa-money-check</v-icon>
                    {{ $t("Receipt.pay") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.pay") }}</span>
              </v-tooltip>

              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('Receipt', 'complete') &&
                  item.status != 3
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      completeDialog = true;
                      currentItem = JSON.parse(JSON.stringify(item));
                    "
                  >
                    <v-icon x-small class="pe-1">fa-receipt</v-icon>
                    {{ $t("Receipt.complete") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.complete") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.bill_check_flg="{ item }">
              <v-chip
                small
                label
                :color="item.bill_check_flg | billCheckFlgColor"
                :text-color="item.bill_check_flg | billCheckFlgTextColor"
              >
                {{ item.bill_check_flg | billCheckFlgText }}
              </v-chip>
            </template>
            <template v-slot:item.pay_flg="{ item }">
              <v-chip
                small
                label
                :color="item.pay_flg | financeFlgsColor"
                :text-color="item.pay_flg | financeFlgsTextColor"
              >
                {{ item.pay_flg | financeFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status | billFlgsColor"
                :text-color="item.status | billFlgsTextColor"
              >
                {{ item.status | billFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.memo="{ item }">
              <span v-if="item.memo && item.memo.length < 6">{{
                item.memo
              }}</span>
              <span v-else>
                <v-tooltip top max-width="480">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ item.memo ? item.memo.substr(0, 6) + "..." : "" }}
                    </span>
                  </template>
                  <span>
                    {{ item.memo }}
                  </span>
                </v-tooltip>
              </span>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <DialogBillCheck
      v-model="billCheckDialog"
      :label="$t('Receipt.bill_check')"
      @confirm="
        CheckBillMemoUpdate({ memo: $event });
        CheckBill();
        billCheckDialog = false;
      "
      addMemo
      :billCheckMemo="checkBillMemo"
    />
    <DialogBillCheck
      v-model="unBillCheckDialog"
      :label="$t('Receipt.uncheck_bill')"
      @confirm="
        UnCheckBill();
        unBillCheckDialog = false;
      "
    />

    <!-- 批量对账 -->
    <DialogBillCheck
      v-model="batchCheckDialog"
      :label="$t('Receipt.batch_bill_check')"
      @confirm="
        batchCheckDialog = false;
        batchCheckingInfoDialog = true;
        batchCheckBill(JSON.parse(JSON.stringify(options)), $event);
      "
      addMemo
    />
    <BatchOperationInfoAlert
      v-model="batchCheckingInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchCheckingInfo"
      persistent
      :closable="errorCount > 0"
    />

    <!-- 批量解除对账 -->
    <DialogAlert
      v-model="batchUncheckDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Receipt.messages.batchUncheckAlert')"
      persistent
      useConfirm
      @confirm="
        batchUncheckDialog = false;
        batchUncheckingInfoDialog = true;
        batchUncheckBill(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchUncheckingInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchUncheckingInfo"
      persistent
      :closable="errorCount > 0"
    />

    <!-- 收付款 -->
    <v-dialog persistent v-model="Dialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{
              currentItem.io_type == 1
                ? $t("ReceiptDetail.Fields.collection")
                : $t("ReceiptDetail.Fields.pay")
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("ReceiptDetail.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <!-- <ValidationObserver ref="observer"> -->
            <v-form>
              <v-row>
                <!-- 要货单/退货单金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 102
                  "
                >
                  <span v-if="currentItem.bill_type == 101">
                    {{
                      $t("ReceiptDetail.receipt.org_price") + $t("Global.colon")
                    }}
                  </span>
                  <span v-if="currentItem.bill_type == 102">
                    {{
                      $t("ReceiptDetail.receipt.return_price") +
                      $t("Global.colon")
                    }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{ currentItem.total_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 采购单/退货出库单金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 201 || currentItem.bill_type == 202
                  "
                >
                  <span v-if="currentItem.bill_type == 201">
                    {{
                      $t("ReceiptDetail.receipt.pur_price") + $t("Global.colon")
                    }}
                  </span>
                  <span v-if="currentItem.bill_type == 202">
                    {{
                      $t("ReceiptDetail.receipt.return_out_price") +
                      $t("Global.colon")
                    }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ currentItem.total_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 调拨单金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 301 || currentItem.bill_type == 302
                  "
                >
                  <span>
                    {{
                      $t("ReceiptDetail.receipt.requisitions_price") + $t("Global.colon")
                    }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{ currentItem.total_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 应收金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 202 || currentItem.bill_type == 301
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.fee_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ currentItem.total_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 应付金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 102 || currentItem.bill_type == 201 || currentItem.bill_type == 302
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.accounts_payable")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ currentItem.total_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 已收 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 202 || currentItem.bill_type == 301
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.net_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{
                      (currentItem.up_sum - currentItem.down_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <!-- 已付 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 102 || currentItem.bill_type == 201 || currentItem.bill_type == 302
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.act_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money")
                    }}{{
                      (currentItem.down_sum - currentItem.up_sum) | formatMoney
                    }}
                  </span>
                </v-col>

                <!-- 未收金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 202 || currentItem.bill_type == 301
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.not_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ wait_receive_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 未付金额 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 102 || currentItem.bill_type == 201 || currentItem.bill_type == 302
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.not_pay_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money") }}{{ wait_pay_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 门店 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 102
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.shop_name")
                    }}{{ $t("Global.colon") }}
                  </span>

                  <span>
                    {{
                      currentItem.shop.shop_name +
                      "(" +
                      currentItem.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <!-- 供应商 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 201 || currentItem.bill_type == 202
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.supplier")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      currentItem.supplier.supplier_name +
                      "(" +
                      currentItem.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <!-- 调拨对象 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 301 || currentItem.bill_type == 302
                  "
                >
                  <span>
                    {{ $t("Receipt.Fields.shop_name") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      currentItem.stock_name +
                      "(" +
                      currentItem.stock_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <!-- 要货单 -->
                <v-col cols="6" v-if="currentItem.bill_type == 101">
                  <span>
                    {{ $t("ReceiptDetail.receipt.org_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ currentItem.org_code }}
                </v-col>
                <!-- 采购单 -->
                <v-col cols="6" v-if="currentItem.bill_type == 201">
                  <span>
                    {{ $t("ReceiptDetail.receipt.pur_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ currentItem.org_code }}
                </v-col>
                <!-- 退货单 -->
                <v-col cols="6" v-if="currentItem.bill_type == 102">
                  <span>
                    {{ $t("ReceiptDetail.receipt.return_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ currentItem.org_code }}
                </v-col>
                <!-- 退货出库单 -->
                <v-col cols="6" v-if="currentItem.bill_type == 202">
                  <span>
                    {{ $t("ReceiptDetail.receipt.return_out_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ currentItem.org_code }}
                </v-col>
                <!-- 调拨单 -->
                <v-col cols="6" v-if="currentItem.bill_type == 301 || currentItem.bill_type == 302">
                  <span>
                    {{ $t("ReceiptDetail.requisitions_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ currentItem.org_code }}
                </v-col>
                <!-- 公司名称 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 102
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.company_name") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ currentItem.shop.company_name }}
                  </span>
                </v-col>
                <!-- 税号 -->
                <v-col
                  cols="6"
                  v-if="
                    currentItem.bill_type == 101 || currentItem.bill_type == 102
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.national_tax_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ currentItem.shop.national_tax_code }}
                  </span>
                </v-col>
                <!-- 日期-->
                <v-col cols="6">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.date")
                    }}{{ $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                    />
                  </span>
                </v-col>
                <!-- 付款金额-->
                <v-col cols="12">
                  <span
                    class="d-flex"
                    v-if="
                      currentItem.bill_type === 102 ||
                      currentItem.bill_type === 201 ||
                      currentItem.bill_type === 302
                    "
                  >
                    {{ $t("ReceiptDetail.receipt.pay_price")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.wait_pay_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                  <span class="d-flex" v-else>
                    {{ $t("ReceiptDetail.receipt.receive_price")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.wait_receive_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                </v-col>
                <!-- 现金折扣 -->
                <v-col cols="12" v-if="settings && settings.cash_discount">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.cash_discount") }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.cash_discount"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="currentItem.cash_discount ? (currentItem.cash_discount = $numberFormatter.formatMoney(currentItem.cash_discount)) : ''"
                    />
                  </span>
                </v-col>
                <!-- 101 102 支付方式-->
                <v-col
                  cols="12"
                  v-if="
                    currentItem.bill_type == 102 || currentItem.bill_type == 101
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method")
                    }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0px"
                      v-model="currentItem.pay_type_shop"
                      :items="
                        !this.$permission.permissionAllow(
                          'Shops',
                          'getShopBalanceHistories'
                        )
                          ? $consts.billTypeReceipt.slice(1)
                          : $consts.billTypeReceipt
                      "
                      item-text="text"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <!-- 201 202 支付方式 -->
                <v-col
                  cols="12"
                  v-if="
                    currentItem.bill_type == 202 || currentItem.bill_type == 201
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method")
                    }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0px"
                      v-model="currentItem.pay_type_supplier"
                      :items="$consts.payTypeReceipt"
                      item-text="text"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <!-- 301 302 支付方式 -->
                <v-col
                  cols="12"
                  v-if="
                    currentItem.bill_type == 301 || currentItem.bill_type == 302
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method") }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0"
                      v-model="currentItem.pay_type_stock"
                      :items="$consts.payTypeReceipt"
                      item-text="text"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <!-- 余额 -->
                <v-col
                  cols="12"
                  v-if="
                    (currentItem.bill_type == 102 ||
                      currentItem.bill_type == 101) &&
                    (currentItem.pay_type_shop == 101 ||
                      currentItem.pay_type_shop == null)
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.balance")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")
                    }}{{ currentItem.shop.balance | formatMoney }}
                  </span>
                  <span
                    v-if="
                      settings &&
                      settings.specified_balance_consumption &&
                      currentItem.bill_type == 101
                    "
                  >
                    （ {{ $t("ReceiptDetail.receipt.specified_balance") }}
                    {{ $t("Global.colon") }}
                    {{ $t("Global.money") }}
                    {{
                      currentItem.shop.specified_balance
                        ? currentItem.shop.specified_balance
                        : 0 | formatMoney
                    }}）
                  </span>
                </v-col>
                <!-- 凭证号？ -->
                <v-col
                  cols="12"
                  v-if="
                    (currentItem.bill_obj_type == 1 &&
                      currentItem.pay_type_shop != 101 &&
                      currentItem.pay_type_shop != null) ||
                    (currentItem.bill_obj_type == 2 &&
                      currentItem.pay_type_supplier != 101 &&
                      currentItem.pay_type_supplier != null) ||
                    (currentItem.bill_obj_type == 3 &&
                      currentItem.pay_type_stock != 101 &&
                      currentItem.pay_type_stock != null)
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.code")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.voucher_code"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <!-- 备注 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="currentItem.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
              </v-row>
            </v-form>
            <!-- </ValidationObserver> -->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="Dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="Confirm()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 归账 -->
    <v-dialog persistent v-model="completeDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("$vuetify.alert") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="completeDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("ReceiptDetail.notice") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="completeDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="Complete()">{{
            $t("CRUD.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherBillType from "@/components/plugins/SearcherBillType";
import SearcherObjType from "@/components/plugins/SearcherObjType";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import Receipt from "@/api/receipt";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import DialogBillCheck from "@/components/plugins/DialogBillCheck";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherShop from "@/components/plugins/SearcherShop";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchOperationInfoAlert from "./plugins/BatchOperationInfoAlert";
import SearcherOrderOriginFlgs from "@/components/plugins/SearcherOrderOriginFlgs.vue";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  purchase_time_from: "",
  purchase_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  order_created_time_from: "",
  order_created_time_to: "",
  stock_finish_time_from: "",
  stock_finish_time_to: "",
  district_ids: [],
  pay_flg: [1, 2, 3],
  bill_check_flg: [0, 1],
  bill_status: [1],
  cancel_flgs: [0],
  bill_types: null,
  obj_type: 1,
  shop_ids: [],
  supplier_ids: [],
  org_code: "",
  bill_code: "",
  order_code: "",
  stock_districts: null,
  stock_id: null,
  stock_ids: [],
  order_status: [],
  beyond_status: [1, 2, 3],
  order_to_purchase_shop_name: "",
  order_to_purchase_shop_id: null,
  origin_flgs: [],
  return_types: [1, 2, 3],
  obj_name: "",
};

export default {
  data: () => ({
    bills: [],
    currentItem: {},
    bill_record_time: new Date().toISOString().substr(0, 10),
    pay_type_shop: 101,
    pay_type_supplier: 102,
    pay_type_stock: 102,
    wait_receive_price: null,
    wait_pay_price: null,

    bill_count: {},
    stocksSelected: null,
    orderToPurchaseShop: null,
    bill_code: "",
    DistrictsSelected: [],
    shopsSelected: [],
    supplierSelected: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("receipt-options")
        ? sessionStorage.getItem("receipt-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    receivable_fee_total: 0,
    wait_receive_total: 0,
    billCheckDialog: false,
    unBillCheckDialog: false,
    Dialog: false,
    completeDialog: false,

    balance: null,
    io_type: null,
    order_price: null,
    obj_name: "",
    shop_code: "",
    total_price: null,
    up_sum: null,
    down_sum: null,
    order_code: null,
    org_code: null,
    supplier_name: null,
    bill_type: null,
    stock_order_total_price: null,
    exportBtnMenu: false,
    purchase_shop_name: "",
    typeFlg: 1,
    billTypesSelected: null,
    orderStatus: [1, 2, 3, 4, 5, 6],
    returnOrderStatus: [1, 2, 3, 4],
    selectShopFlg: false,
    checkBillMemo: "",
    checkBtnMenu: false,
    error_bill_id: [],
    batchCheckMemo: "",
    batchCheckDialog: false,
    batchCheckingInfoDialog: false,
    batchCheckingInfo: i18n.t("Receipt.messages.batchCheckInfo", [0, 0]),
    batchUncheckDialog: false,
    batchUncheckingInfoDialog: false,
    batchUncheckingInfo: i18n.t("Receipt.messages.batchUncheckInfo", [0, 0]),
    errorCount: 0,
    successCount: 0,
  }),
  components: {
    SearcherOrderOriginFlgs,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherKeyword,
    SearcherBillType,
    SearcherObjType,
    SearcherDistrictsWithDescendants,
    SearcherStocks,
    SearcherStatus,
    DialogBillCheck,
    SearcherDatetime,
    SearcherShops,
    SearcherShop,
    SearcherSuppliers,
    DialogAlert,
    BatchOperationInfoAlert,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    collect() {
      if (this.options.obj_type == 1) {
        return true;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    pay() {
      if (this.options.obj_type == 2) {
        return true;
      }
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receipt"),
        disabled: true,
        href: "/receipt-bill-analyze",
      },
    ],
    datetimeRadios() {
      let radio = [
        {
          key: "created",
          text: i18n.t("Receipt.Fields.created_time"),
        },
        {
          key: "stock_finish",
          text: i18n.t("Receipt.Fields.stock_finish_time"),
        },
        {
          key: "actual",
          text: i18n.t("Receipt.Fields.actual_time"),
        },
      ];
      if (this.billTypesSelected == 102) {
        radio.push({
          key: "order_created",
          text: i18n.t("Receipt.Fields.order_created_time"),
        });
      } else {
        radio.push({
          key: "purchase",
          text: i18n.t("Receipt.Fields.purchase_time"),
        });
      }
      if (this.options.obj_type == 1) {
        radio.push({
          key: "expect",
          text:
            this.billTypesSelected == 102
              ? i18n.t("Receipt.Fields.order_expect_time")
              : i18n.t("StockOrderOUT.Fields.expect_time"),
        });
      }
      return radio;
    },
    headers() {
      var headers = [
        {
          text: i18n.t("Receipt.Fields.bill_code"),
          align: "start",
          sortable: false,
          value: "bill_code",
        },
        {
          text: i18n.t("Receipt.Fields.org_code"),
          align: "start",
          sortable: false,
          value: "org_code",
        },
        {
          text: i18n.t("Receipt.Fields.shop_name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
      ];
      if (this.options.obj_type == 1 && this.billTypesSelected == 102) {
        headers.push(
          {
            text: i18n.t("ReturnOrder.Fields.type"),
            align: "center",
            class: "text-no-wrap",
            sortable: false,
            value: "order_return_type",
          },
        )
      }
      headers.push(
        {
          text: i18n.t("Receipt.Fields.fee"),
          align: "start",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("Receipt.Fields.wait_fee"),
          align: "start",
          sortable: false,
          width: "140px",
          value: "wait_fee",
        },
        {
          text: i18n.t("Receipt.Fields.credential_str"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "credential_str",
        },
        {
          text: i18n.t("Receipt.Fields.bill_check_flg"),
          align: "start",
          sortable: false,
          value: "bill_check_flg",
        },
        {
          text: i18n.t("Receipt.Fields.pay_flg"),
          align: "start",
          sortable: false,
          value: "pay_flg",
        },
        {
          text: i18n.t("Receipt.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Receipt.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Receipt.Fields.memo"),
          align: "start",
          sortable: false,
          width: 140,
          value: "memo",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
          width: 420,
        })
      return headers;
    },
    ...mapState(["stickTableCols", "settings"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("receipt", [
        "DistrictsSelected",
        "stocksSelected",
        "orderToPurchaseShop",
        "shopsSelected",
        "supplierSelected",
        "billTypesSelected",
        "orderStatus",
        "returnOrderStatus",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "orderToPurchaseShop":
                this.orderToPurchaseShop = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
              case "billTypesSelected":
                this.billTypesSelected = selected.value;
                break;
              case "orderStatus":
                this.orderStatus = selected.value;
                break;
              case "returnOrderStatus":
                this.returnOrderStatus = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        org_code: this.org_code,
        bill_code: this.bill_code,
        order_code: this.order_code,
        order_to_purchase_shop_name: this.purchase_shop_name,
        obj_name: this.obj_name
      });
    },
    resetSearch() {
      this.stocksSelected = null;
      this.orderToPurchaseShop = null;
      this.DistrictsSelected = [];
      this.shopsSelected = [];
      this.supplierSelected = [];
      this.billTypesSelected = null;
      this.orderStatus = [1, 2, 3, 4, 5, 6];
      this.returnOrderStatus = [1, 2, 3, 4];
      this.options = Object.assign(
        {},
        JSON.parse(JSON.stringify(defaultOptions)),
        {
          page: 1,
          itemsPerPage: 30,
        }
      );
      [this.$refs.obj_name, this.$refs.org_code, this.$refs.bill_code, this.$refs.order_code, this.$refs.order_to_purchase_shop_name].forEach((k) => {
        if (k) k.clear();
      });
    },
    getReceiptFromAPI() {
      this.loading = true;
      if (this.options.obj_type != 2) {
        delete this.options.order_to_purchase_shop_name;
        delete this.options.order_to_purchase_shop_id;
      }
      if (this.billTypesSelected != 102) {
        delete this.options.return_types
      }
      Receipt.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bills = response.data.bills;

            this.bill_count = response.data.bill_count;
            this.receivable_fee_total =
              response.data.bill_count.receivable_fee_total;
            this.wait_receive_total =
              response.data.bill_count.wait_receive_total;

            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    CheckBill() {
      Receipt.checkBill(this.itemId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptFromAPI();
          }
        }.bind(this)
      );
    },
    UnCheckBill() {
      Receipt.unCheckBill(this.itemId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptFromAPI();
          }
        }.bind(this)
      );
    },
    CheckBillMemoUpdate(data) {
      Receipt.CheckBillMemoUpdate(this.itemId, data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getReceiptFromAPI();
          }
        }.bind(this)
      );
    },
    Confirm() {
      this.$store.dispatch("fullscreenLoading");
      // console.log(this.currentItem);
      // console.log(this.currentItem.id);
      // var _this = this;
      // console.log(_this);
      // var bill_id = this.id;
      var pay_price = 0;
      var bill_pay_type = 0;
      if (
        this.currentItem.bill_type == 101 ||
        this.currentItem.bill_type == 202 ||
        this.currentItem.bill_type == 203 ||
        this.currentItem.bill_type == 301
      ) {
        pay_price = this.currentItem.wait_receive_price;
      } else {
        pay_price = this.currentItem.wait_pay_price;
      }
      if (
        this.currentItem.bill_type == 102 ||
        this.currentItem.bill_type == 101
      ) {
        bill_pay_type = this.currentItem.pay_type_shop;
      } else if (
        this.currentItem.bill_type == 201 ||
        this.currentItem.bill_type == 202 ||
        this.currentItem.bill_type == 203
      ) {
        bill_pay_type = this.currentItem.pay_type_supplier;
      } else if (
        this.currentItem.bill_type == 301 ||
        this.currentItem.bill_type == 302
      ) {
        bill_pay_type = this.currentItem.pay_type_stock;
      }

      // 指定余额支付逻辑
      if (this.settings && this.settings.specified_balance_consumption && this.currentItem.bill_type == 101 && bill_pay_type == 101 && (pay_price > this.currentItem.shop.specified_balance)) {
        this.$snackbar.error(i18n.t("ReceiptDetail.specified_balance"));
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      var data = {
        bill_id: this.currentItem.id,
        bill_record_time: this.currentItem.bill_record_time,
        // pay_type: this.currentItem.pay_type,
        pay_type: bill_pay_type,
        comment: this.currentItem.comment,
        voucher_code: this.currentItem.voucher_code,
        price: pay_price,
        cash_discount: this.currentItem.cash_discount,
      };
      // data;
      Receipt.saveBillRecord(data)
        .then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.Dialog = false;
                this.getReceiptFromAPI();
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    Complete() {
      this.$store.dispatch("fullscreenLoading");
      Receipt.complete(this.currentItem.id)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.completeDialog = false;
              this.getReceiptFromAPI();
            } else {
              this.completeDialog = false;
              this.getReceiptFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    exportExcel() {
      Receipt.exportExcel(Object.assign({}, this.options));
    },
    exportBatchExcel() {
      Receipt.exportBatchExcel(Object.assign({}, this.options));
    },
    subAccountReceivableDetailExport() {
      Receipt.subAccountReceivableDetailExport(Object.assign({}, this.options));
    },
    download(e) {
      if (this.options.datetimeRadioSelected == "actual") {
        this.time_type = 2;
      } else if (this.options.datetimeRadioSelected == "created") {
        this.time_type = 1;
      } else if (this.options.datetimeRadioSelected == "purchase") {
        this.time_type = 3;
      }
      Receipt.download(Object.assign({ id: e, time_type: this.time_type }));
    },
    orderBillRecordsExport() {
      if (this.options.obj_type != 2) {
        delete this.options.order_to_purchase_shop_name;
      }
      Receipt.orderBillRecordsExport(Object.assign({}, this.options));
    },
    resourceOrderExport() {
      Receipt.resourceOrderExport(Object.assign({}, this.options));
    },
    supplierOrderExport() {
      Receipt.supplierOrderExport(Object.assign({}, this.options));
    },
    resourceReturnOrderExport() {
      Receipt.resourceReturnOrderExport(Object.assign({}, this.options));
    },
    resourceOrderPaymentExport() {
      Receipt.resourceOrderPaymentExport(Object.assign({}, this.options));
    },
    billTypeChange() {
      if (
        this.options.obj_type == 1 &&
        (this.options.datetimeRadioSelected == "order_created" ||
          this.options.datetimeRadioSelected == "purchase")
      ) {
        this.options = Object.assign({}, this.options, {
          datetimeRadioSelected: "created",
          created_time_from:
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00",
          created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
          actual_time_from: "",
          actual_time_to: "",
          purchase_time_from: "",
          purchase_time_to: "",
          expect_time_from: "",
          expect_time_to: "",
          order_created_time_from: "",
          order_created_time_to: "",
          stock_finish_time_from: "",
          stock_finish_time_to: "",
        });
      }
    },
    batchCheckBill(options, memo) {
      if (this.error_bill_id.length) {
        options.no_bill_ids = this.error_bill_id;
      }
      options.check_memo = memo;
      Receipt.batchCheckBill(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.check_flg) {
              ++this.successCount;
            } else {
              this.error_bill_id.push(response.data.bill_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              if (response.data.error.code == "ERR319") {
                // 接口无权限适配
                this.getReceiptFromAPI();
                options = null;
                this.error_bill_id = [];
                this.successCount = 0;
                this.errorCount = 0;
                this.batchCheckingInfoDialog = false;
                return;
              } else {
                this.error_bill_id.push(response.data.bill_id);
                ++this.errorCount;
              }
            } else {
              this.getReceiptFromAPI();
              options = null;
              this.error_bill_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.batchCheckingInfoDialog = false;
            }
          }
          //实时计数
          this.batchCheckingInfo = i18n.t("Receipt.messages.batchCheckInfo", [
            this.successCount,
            this.errorCount,
          ]);
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchCheckBill(options, memo);
          }
        }.bind(this)
      );
    },
    batchUncheckBill(options) {
      if (this.error_bill_id.length) {
        options.no_bill_ids = this.error_bill_id;
      }
      Receipt.batchUncheckBill(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.uncheck_flg) {
              ++this.successCount;
            } else {
              this.error_bill_id.push(response.data.bill_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              if (response.data.error.code == "ERR319") {
                this.getReceiptFromAPI();
                options = null;
                this.error_bill_id = [];
                this.successCount = 0;
                this.errorCount = 0;
                this.batchUncheckingInfoDialog = false;
                return;
              } else {
                this.error_bill_id.push(response.data.bill_id);
                ++this.errorCount;
              }
            } else {
              this.getReceiptFromAPI();
              options = null;
              this.error_bill_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.batchUncheckingInfoDialog = false;
            }
          }
          //实时计数
          this.batchUncheckingInfo = i18n.t(
            "Receipt.messages.batchUncheckInfo",
            [this.successCount, this.errorCount]
          );
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchUncheckBill(options);
          }
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        if (this.options.obj_type != this.typeFlg) {
          this.typeFlg = this.options.obj_type;
          this.stocksSelected = null;
          this.orderToPurchaseShop = null;
          this.DistrictsSelected = [];
          this.shopsSelected = [];
          this.supplierSelected = [];
          this.billTypesSelected = null;
          this.orderStatus = [1, 2, 3, 4, 5, 6];
          this.returnOrderStatus = [1, 2, 3, 4];
          this.options = Object.assign(
            {},
            JSON.parse(JSON.stringify(defaultOptions)),
            {
              page: 1,
              itemsPerPage: 30,
              obj_type: this.options.obj_type,
            }
          );
        }
        this.getReceiptFromAPI();
        sessionStorage.setItem("receipt-options", JSON.stringify(this.options));
      },
    },
    // 组别
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "receipt-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "receipt-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.supplier_ids = this.supplierSelected
          ? this.supplierSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "receipt-supplierSelected",
          JSON.stringify(this.supplierSelected)
        );
      },
    },
    orderStatus: {
      handler() {
        this.options.order_status = this.orderStatus;
        sessionStorage.setItem(
          "receipt-orderStatus",
          JSON.stringify(this.orderStatus)
        );
      },
    },
    returnOrderStatus: {
      handler() {
        this.options.order_status = this.returnOrderStatus;
        sessionStorage.setItem(
          "receipt-returnOrderStatus",
          JSON.stringify(this.returnOrderStatus)
        );
      },
    },
    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "receipt-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 订单转采购门店
    orderToPurchaseShop: {
      handler() {
        this.options.order_to_purchase_shop_id = this.orderToPurchaseShop
          ? this.orderToPurchaseShop.id
          : [];
        sessionStorage.setItem(
          "receipt-orderToPurchaseShop",
          JSON.stringify(this.orderToPurchaseShop)
        );
      },
    },
    selectShopFlg: {
      handler() {
        if (this.selectShopFlg) {
          this.options.order_to_purchase_shop_name = "";
          this.purchase_shop_name = "";
        } else {
          this.orderToPurchaseShop = null;
        }
      },
    },
    billTypesSelected: {
      handler() {
        if (this.billTypesSelected == 101) {
          this.options.order_status = this.orderStatus;
        } else if (this.billTypesSelected == 102) {
          this.options.order_status = this.returnOrderStatus;
        } else {
          this.options.order_status = [];
        }
        this.options.origin_flgs = [];
        this.options.bill_types = this.billTypesSelected
          ? this.billTypesSelected
          : null;
        sessionStorage.setItem(
          "receipt-billTypesSelected",
          JSON.stringify(this.billTypesSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>